<ng-container [ngSwitch]="status">
    <!-- Verification -->
    <div *ngSwitchCase="VerifyAndEarnPromotionStatus.Verification" class="alert">
        <div class="content flex-grow-1">
            <h4 class="text-bold">
                <span *ngIf="asterisk">* </span>
                <ng-container i18n="@@promotionNotiifcation.verifyAndEarn.verification.title">Your account is not verified</ng-container>
            </h4>
            <p class="text-sm" i18n="@@promotionNotiifcation.verifyAndEarn.verification.text">Verify your account to activate your {{verifyAndEarn?.reward?.currency}} {{verifyAndEarn?.reward?.amount}} reward</p>
        </div>
        <div class="p-2"></div>
        <div class="actions">
            <a routerLink="/verification" class="btn btn-sm rounded" i18n="@@promotionNotiifcation.verifyAndEarn.verification.action">Verify now</a>
        </div>
    </div>

     <!-- Retry Verification -->
     <div *ngSwitchCase="VerifyAndEarnPromotionStatus.RetryVerification" class="alert">
        <div class="content flex-grow-1">
            <h4 class="text-bold">
                <span *ngIf="asterisk">* </span>
                <ng-container i18n="@@promotionNotiifcation.verifyAndEarn.retryVerification.title">Oops... your document was not accepted</ng-container>
            </h4>
            <p class="text-sm" i18n="@@promotionNotiifcation.verifyAndEarn.retryVerification.text">Make sure you upload a clear copy of the required document</p>
        </div>
        <div class="p-2"></div>
        <div class="actions">
            <a routerLink="/verification" class="btn btn-sm rounded" i18n="@@promotionNotiifcation.verifyAndEarn.retryVerification.action">Upload document</a>
        </div>
    </div>

    <!-- In Review -->
    <div *ngSwitchCase="VerifyAndEarnPromotionStatus.InReview" class="alert">
        <div class="content flex-grow-1">
            <h4 class="text-bold">
                <span *ngIf="asterisk">* </span>
                <ng-container i18n="@@promotionNotiifcation.verifyAndEarn.inReview.title">We’re processing your verification</ng-container>
            </h4>
            <p class="text-sm" i18n="@@promotionNotiifcation.verifyAndEarn.inReview.text">If a manual check is required, this may take longer than usual</p>
        </div>
    </div>

    <!-- Deposit -->
    <div *ngSwitchCase="VerifyAndEarnPromotionStatus.Deposit" class="alert">
        <div class="content flex-grow-1">
            <h4 class="text-bold">
                <span *ngIf="asterisk">* </span>
                <ng-container i18n="@@promotionNotiifcation.verifyAndEarn.deposit.title">Your {{verifyAndEarn?.reward?.currency}} {{verifyAndEarn?.reward?.amount}} is waiting for you...</ng-container>
            </h4>
            <p class="text-sm" i18n="@@promotionNotiifcation.verifyAndEarn.deposit.text">Deposit a minimum of {{verifyAndEarn?.minDeposit?.currency}} {{verifyAndEarn?.minDeposit?.amount}} to unlock your {{verifyAndEarn?.reward?.currency}} {{verifyAndEarn?.reward?.amount}} reward</p>
        </div>
        <div class="p-2"></div>
        <div class="actions">
            <a routerLink="/accounts/fiat/deposit" class="btn btn-sm rounded" i18n="@@promotionNotiifcation.verifyAndEarn.deposit.action">Deposit now</a>
        </div>
    </div>
</ng-container>